// STORE DEPENDANCY
import { Action } from '@ngrx/store';

// COMMON INTERFACES
import { ApiPayload } from '../../../../models/common/api/api-payload.interface';

export enum ActionTypes {
  // MASTER PERMISSION ACTIONS
  PERMISSION_COMMON = '[Permission] Permission Common',
  PERMISSION_COMMON_SUCCESS = '[Permission] Permission Common Success',
}

// -------------------------------
//  Permission Common
// -------------------------------
export class PermissionCommonAction implements Action {
  readonly type = ActionTypes.PERMISSION_COMMON;
  constructor(public payload: ApiPayload) { }
}

// -------------------------------
//  Permission Common Success
// -------------------------------
export class PermissionCommonSuccessAction implements Action {
  readonly type = ActionTypes.PERMISSION_COMMON_SUCCESS;
  constructor(public response?: any) { }
}

export type Actions =
  | PermissionCommonAction
  | PermissionCommonSuccessAction;
